import { t } from "i18next";
import { useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import { LoadingSpinner } from "../../general/loading-spinner";

export function TeamsStatistics() {
    const params: any = useParams();

    const [loaded, setLoaded] = useState(true);

    useEffect(() => {
        
    }, []);
    
    return (
        <div className="teams-ranking-container"> 
            <div className="inner">
            { !loaded && 
                <LoadingSpinner />
            }
            { loaded && 
                <h1>{ t("Teams statistics") }</h1>
            }
            </div>
        </div>
    );
}